<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink } from 'vue-router'
import { useRuntimeStore } from '../stores/runtime'

const store = useRuntimeStore()
const folders = computed(() => store.navigation.folders.filter(item => item.parent_id === null).sort((a,b) => a.sort - b.sort))
const forms = computed(() => store.navigation.publications.filter(item => item.folder_id === null).sort((a,b) => a.sort - b.sort))
</script>

<template>
  <section>
    <div class="page-head">
      <div><h1>Формы</h1><p>Выберите папку или форму.</p></div>
    </div>
    <div v-if="!folders.length && !forms.length" class="empty-state">Для этого портала пока нет опубликованных форм.</div>
    <div class="explorer-grid">
      <RouterLink v-for="folder in folders" :key="folder.id" class="explorer-item folder" :to="`/folders/${folder.id}`">
        <div class="explorer-icon">▰</div>
        <div><strong>{{ folder.name }}</strong><small v-if="folder.description">{{ folder.description }}</small></div>
      </RouterLink>
      <RouterLink v-for="form in forms" :key="form.id" class="explorer-item form" :to="`/forms/${form.public_key}`">
        <div class="explorer-icon">▤</div>
        <div><strong>{{ form.name }}</strong><small v-if="form.description">{{ form.description }}</small></div>
      </RouterLink>
    </div>
  </section>
</template>
